import { render, staticRenderFns } from "./fccTitulo.vue?vue&type=template&id=4d05ee38"
import script from "./fccTitulo.vue?vue&type=script&lang=js"
export * from "./fccTitulo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports